var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('rkm-area',{attrs:{"title":"Procedimentos Feridas"}},[_c('rkm-row',[_c('rkm-col',{attrs:{"cols":"12"}},[_c('List',{attrs:{"data":_vm.data},on:{"edit":function($event){return _vm.$refs.Modal.open($event)},"remove":_vm.remove}})],1)],1)],1),_c('Modal',{ref:"Modal",attrs:{"data":_vm.modalData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }